import { UNITS } from 'src/researcher/styles';

export const WIDTH_MARGIN_TRANSITION_TIME = '0.3s';
export const DOM_MAIN_ID = 'main-container';
export const DOM_SIDEBAR_ID = 'sidebar-container';
export const HEADER_Z_INDEX = 1200;
export const SIDEBAR_Z_INDEX = HEADER_Z_INDEX + 1;
export const FIXED_SIDEBAR_WIDTH = UNITS['7pt'];
export const EXPANDED_FIXED_SIDEBAR = UNITS['12pt'];
export const SIDEBAR_WIDTH = UNITS['60pt'];
export const TOOL_PANE_HEADER_Z_INDEX = SIDEBAR_Z_INDEX + 2;
